(function () {
    'use strict';

    angular.module('sempraWebapp').factory('DailyEuroKeyReportViewModel', DailyEuroKeyReportViewModelFactory);

    /** @ngInject */
    function DailyEuroKeyReportViewModelFactory(reportActions, reportsFilterStore, localeFilters, dispatcher, ActionTypesEnum) {
        function DailyEuroKeyReportViewModel() {
            this._reportsFilterStoreChangeHandler = null;
            this.chart = {
                data: null,
                x: {
                    type: 'timeseries',
                    tick: {
                        culling: {max: 15},
                        rotate: 60,
                        format: function (item) {
                            return localeFilters.date(item);
                        }
                    }
                }
            };

            init.call(this);
        }

        DailyEuroKeyReportViewModel.prototype.destroy = function () {
            reportsFilterStore.off(reportsFilterStore.events.CHANGE, this._reportsFilterStoreChangeHandler);
        };

        return DailyEuroKeyReportViewModel;

        function init() {
            var that = this;
            this.isChartVisible = false;

            searchByFilter.call(that);
            this._reportsFilterStoreChangeHandler = function () {
                searchByFilter.call(that);
            };

            reportsFilterStore.on(reportsFilterStore.events.CHANGE, this._reportsFilterStoreChangeHandler);
        }

        function searchByFilter() {
            var that = this,
                reportFilterData = reportsFilterStore.getFilterData();

            reportActions.getTotalEuroKeyByDate('', reportFilterData.fromTimestamp, reportFilterData.toTimestamp).then(function (successData) {
                that.chart.data = successData;
                that.isChartVisible = (successData.total !== 0) ? true : false;
                dispatcher.dispatch({
                    type: ActionTypesEnum.HIDE_LOADER
                });
            });
        }
    }
})();
